/* Gravur-Designer
 * Eingabefelder im Formular, Live-Vorschau als Overlay in der Bildergalerie.
 * Öffnet sich beim Personalisieren; Schriftfarbe folgt der Variantenwahl.
 */
(function () {
  'use strict';

  var GHOST_NAMEN = 'Julia\n& Alex';
  var GHOST_DATUM = '17.08.2027';
  /* Die Front wird immer in der Druckschrift graviert */
  var FRONT_FONT = 'GravurSchrift6';
  var FRONT_SCALE = 0.72;

  /* Zweizeilig trennen – das "&" wandert in die kürzere Zeile */
  function splitNamen(v) {
    v = v.trim();
    if (!v) return '';
    var amp = v.indexOf('&');
    if (amp > -1) {
      var left = v.slice(0, amp).trim();
      var right = v.slice(amp + 1).trim();
      if (left && right) {
        return left.length <= right.length
          ? left + ' &\n' + right
          : left + '\n& ' + right;
      }
    }
    var words = v.split(/\s+/);
    if (words.length > 1) {
      var mid = Math.ceil(words.length / 2);
      return words.slice(0, mid).join(' ') + '\n' + words.slice(mid).join(' ');
    }
    return v;
  }

  /* Klassisches Datumsformat? (z.B. 17.08.2027) */
  function isClassicDate(v) {
    return /^\d{1,2}\.\s?\d{1,2}\.\s?\d{2,4}$/.test(v.trim());
  }

  function boot() {
    var fields = document.querySelector('[data-gravur-vorschau]');
    var wrap = document.querySelector('[data-gravur-stage-wrap]');
    if (!fields || !wrap || wrap.dataset.gravurInit) return;
    wrap.dataset.gravurInit = '1';

    var stage = wrap.querySelector('[data-gravur-stage]');
    var img = wrap.querySelector('[data-gravur-img]');
    var textEl = wrap.querySelector('[data-gravur-text]');
    var noNote = wrap.querySelector('[data-gravur-nonote]');
    var namenInput = fields.querySelector('[data-gravur-namen]');
    var datumInput = fields.querySelector('[data-gravur-datum]');
    var fontRadios = Array.prototype.slice.call(fields.querySelectorAll('[data-gravur-font-option]'));
    var fontProbes = Array.prototype.slice.call(fields.querySelectorAll('[data-gravur-probe]'));
    var showLink = fields.querySelector('[data-gravur-show]');
    var mini = fields.querySelector('[data-gravur-mini]');
    var miniThumb = fields.querySelector('[data-gravur-mini-thumb]');
    var miniImg = fields.querySelector('[data-gravur-mini-img]');
    var miniText = fields.querySelector('[data-gravur-mini-text]');
    var stageSichtbar = false;
    var form = document.getElementById(fields.dataset.formId);

    function currentView() {
      return stage.dataset.view;
    }

    function currentText() {
      if (currentView() === 'oben') {
        return splitNamen(namenInput.value) || GHOST_NAMEN;
      }
      return datumInput.value.trim() || GHOST_DATUM;
    }

    function isGhost() {
      return currentView() === 'oben' ? !namenInput.value.trim() : !datumInput.value.trim();
    }

    function checkedRadioValues() {
      var scope = form || document;
      var radios = scope.querySelectorAll('input[type="radio"]:checked');
      var values = [];
      for (var i = 0; i < radios.length; i++) values.push((radios[i].value || '').toLowerCase());
      return values;
    }

    function noEngraving() {
      /* Variante ohne Gravur/Beschriftung gewählt? */
      var values = checkedRadioValues();
      for (var i = 0; i < values.length; i++) {
        if (
          values[i].indexOf('no names') !== -1 ||
          values[i].indexOf('ohne gravur') !== -1 ||
          values[i].indexOf('ohne beschriftung') !== -1
        ) return true;
      }
      return false;
    }

    function currentColor() {
      /* Schriftfarbe-Variante: "Gold" / "Weiß" (alt: "Font gold" / "font white") */
      var values = checkedRadioValues();
      for (var i = 0; i < values.length; i++) {
        var v = values[i];
        if (v === 'gold' || (v.indexOf('gold') !== -1 && v.indexOf('font') !== -1)) return 'gold';
        if (v.indexOf('wei') === 0 || v.indexOf('white') !== -1) return 'white';
      }
      return 'white';
    }

    function checkedFontRadio() {
      for (var i = 0; i < fontRadios.length; i++) {
        if (fontRadios[i].checked) return fontRadios[i];
      }
      return fontRadios[0];
    }

    function currentFont() {
      var r = checkedFontRadio();
      return r ? r.dataset.font : 'GravurSchrift1';
    }

    function updateProbes() {
      var probe = splitNamen(namenInput.value).replace('\n', ' ') || 'Julia & Alex';
      fontProbes.forEach(function (el) { el.textContent = probe; });
    }

    function layoutStage() {
      /* Position des per object-fit: contain gerenderten (quadratischen)
         Bildes im Container als CSS-Variablen bereitstellen */
      var w = stage.clientWidth;
      var h = stage.clientHeight;
      if (!w || !h) return 0;
      var s = Math.min(w, h);
      wrap.style.setProperty('--is', s + 'px');
      wrap.style.setProperty('--ix', (w - s) / 2 + 'px');
      wrap.style.setProperty('--iy', '0px');
      return s;
    }

    function fitText() {
      /* An die Gravurfläche angepasst; breite/fette Schriften starten kleiner */
      var r = checkedFontRadio();
      var scale = r && r.dataset.scale ? parseFloat(r.dataset.scale) : 1;
      if (currentView() === 'front') scale = FRONT_SCALE;
      var imgSize = layoutStage() || stage.clientWidth;
      var max = imgSize * (currentView() === 'oben' ? 0.115 : 0.08) * scale;
      var min = 12;
      var size = max;
      textEl.style.fontSize = size + 'px';
      var guard = 30;
      while (
        guard-- > 0 &&
        size > min &&
        (textEl.scrollWidth > textEl.clientWidth || textEl.scrollHeight > textEl.clientHeight)
      ) {
        size -= 2;
        textEl.style.fontSize = size + 'px';
      }
    }

    function styledLidText(radio) {
      /* Deckeltext mit Schrift-Feinjustierung: engeres & bei data-amp="eng" */
      var t = currentText();
      if (currentView() === 'oben' && radio && radio.dataset.amp === 'eng') {
        t = t.replace(' &', '&').replace('& ', '&');
      }
      return t;
    }

    function render() {
      var off = noEngraving();
      fields.classList.toggle('is-hidden', off);
      if (off) wrap.classList.remove('is-open');
      wrap.classList.toggle('is-off', off);
      if (noNote) noNote.hidden = !off;
      var pflicht = fields.querySelector('[data-gravur-pflicht]');
      if (pflicht) pflicht.hidden = off;
      namenInput.disabled = off;
      datumInput.disabled = off;
      fontRadios.forEach(function (r) { r.disabled = off; });
      textEl.style.display = off ? 'none' : '';
      var fontRadio = checkedFontRadio();
      textEl.textContent = styledLidText(fontRadio);
      textEl.style.fontFamily = "'" + (currentView() === 'front' ? FRONT_FONT : currentFont()) + "', cursive";
      textEl.style.lineHeight = currentView() === 'oben' && fontRadio && fontRadio.dataset.lh ? fontRadio.dataset.lh : '1.22';
      var datumWert = datumInput.value.trim() || GHOST_DATUM;
      textEl.classList.toggle('is-spaced', currentView() === 'front' && isClassicDate(datumWert));
      textEl.classList.toggle('is-gold', currentColor() === 'gold');
      textEl.classList.toggle('is-white', currentColor() !== 'gold');
      textEl.style.opacity = isGhost() ? '0.45' : '1';
      fitText();
      renderMini(off);
    }

    function istMobil() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function renderMini(off) {
      if (!mini) return;
      var hatEingabe = namenInput.value.trim() || datumInput.value.trim();
      var zeigen = istMobil() && !off && hatEingabe && !stageSichtbar;
      mini.hidden = !zeigen;
      if (!zeigen) return;
      var view = currentView();
      miniThumb.dataset.view = view;
      miniImg.src = view === 'front' ? img.dataset.srcFront : img.dataset.srcOben;
      var miniRadio = checkedFontRadio();
      miniText.textContent = styledLidText(miniRadio);
      miniText.style.fontFamily = "'" + (view === 'front' ? FRONT_FONT : currentFont()) + "', cursive";
      miniText.style.lineHeight = view === 'oben' && miniRadio && miniRadio.dataset.lh ? miniRadio.dataset.lh : '1.2';
      miniText.classList.toggle('is-gold', currentColor() === 'gold');
      miniText.classList.toggle('is-white', currentColor() !== 'gold');
    }

    function setView(view) {
      stage.dataset.view = view;
      img.src = view === 'front' ? img.dataset.srcFront : img.dataset.srcOben;
      wrap.querySelectorAll('[data-gravur-view]').forEach(function (b) {
        var active = b.dataset.gravurView === view;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      render();
    }

    function open(view) {
      wrap.classList.add('is-open');
      setView(view || currentView());
    }

    function close() {
      wrap.classList.remove('is-open');
    }

    wrap.querySelectorAll('[data-gravur-view]').forEach(function (btn) {
      btn.addEventListener('click', function () { setView(btn.dataset.gravurView); });
    });
    wrap.querySelector('[data-gravur-close]').addEventListener('click', close);

    /* Leere Felder nicht als Property mitbestellen */
    function syncNames() {
      if (namenInput.value.trim()) namenInput.setAttribute('name', 'properties[Namen]');
      else namenInput.removeAttribute('name');
      if (datumInput.value.trim()) datumInput.setAttribute('name', 'properties[Datum oder Koordinaten]');
      else datumInput.removeAttribute('name');
    }
    namenInput.addEventListener('input', syncNames);
    datumInput.addEventListener('input', syncNames);
    syncNames();

    namenInput.addEventListener('focus', function () { open('oben'); });
    datumInput.addEventListener('focus', function () { open('front'); });

    namenInput.addEventListener('input', function () { updateProbes(); render(); });
    datumInput.addEventListener('input', render);
    fontRadios.forEach(function (r) {
      r.addEventListener('change', function () { open(); render(); });
    });

    if (showLink) {
      showLink.addEventListener('click', function () {
        open('oben');
        wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }

    if (form) form.addEventListener('change', function () { window.setTimeout(render, 30); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') window.setTimeout(render, 30);
    });
    img.addEventListener('load', render);
    window.addEventListener('resize', function () { layoutStage(); fitText(); });

    /* Namen sind Pflicht, wenn "Mit Gravur" gewählt ist */
    var errorEl = fields.querySelector('[data-gravur-error]');

    function namenFehlt() {
      return !noEngraving() && !namenInput.value.trim();
    }

    function zeigeNamenFehler() {
      if (errorEl) errorEl.hidden = false;
      namenInput.classList.add('is-invalid');
      fields.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.setTimeout(function () { namenInput.focus({ preventScroll: true }); }, 350);
    }

    namenInput.addEventListener('input', function () {
      if (namenInput.value.trim()) {
        if (errorEl) errorEl.hidden = true;
        namenInput.classList.remove('is-invalid');
      }
    });

    document.addEventListener('click', function (e) {
      var kaufBtn = e.target.closest('[data-add-to-cart], button[name="add"]');
      if (!kaufBtn) return;
      var btnFormEl = kaufBtn.closest('form');
      var btnForm = kaufBtn.getAttribute('form') || (btnFormEl && btnFormEl.getAttribute('id'));
      if (btnForm && btnForm !== fields.dataset.formId) return;
      if (namenFehlt()) {
        e.preventDefault();
        e.stopPropagation();
        zeigeNamenFehler();
      }
    }, true);

    if (mini) {
      mini.addEventListener('click', function () {
        open(currentView());
        wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
        mini.hidden = true;
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          stageSichtbar = entries[0].isIntersecting;
          renderMini(noEngraving());
        }, { threshold: 0.25 });
        io.observe(wrap.parentElement || wrap);
      }
    }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
    updateProbes();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
